import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HomeGraphData, MyTask } from './home.model';
import { Observable } from 'rxjs';
import { API_URL } from '../app.constants';
import { TableData } from '../shared/shared.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private http: HttpClient) { }

  getHomeGraphData(): Observable<HomeGraphData> {
    return this.http.get<HomeGraphData>(`${API_URL}/home`);
  }

  getMyTasks(page: number = 0, pageSize: number = 10, searchKeyword: string = ''): Observable<TableData<MyTask>> {

    return this.http.get<TableData<MyTask>>(`${API_URL}/home/tasks`, {
      params: {
        SearchKeyword: searchKeyword,
        Page: (++page).toString(),
        PageSize: pageSize.toString(),
      },
    }).pipe(
      map((res: TableData<MyTask>) => {
        res.page--;

        return res;
      })
    );
  }
}
